export const isScrollThreasholdReached = (index: number, listLength: number) =>
  index === listLength - 1;
